import { IntlProvider, ReactIntlErrorCode } from 'react-intl'
import { observer } from 'mobx-react'
import langRu from './translations/ru.json'
import langEn from './translations/en.json'
import langKg from './translations/kg.json'
import langTj from './translations/tj.json'
import { createContext, useContext, useEffect } from 'react'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import localeRu from 'date-fns/locale/ru'
import localeEn from 'date-fns/locale/en-US'
import { useStore } from 'hooks'

const messages = {
  ru: langRu,
  en: langEn,
  kg: langKg,
  tj: langTj,
}

registerLocale('ru', localeRu)
registerLocale('en', localeEn)

const IntlContext = createContext({
  switchToEnglish: () => {},
  switchToRussian: () => {},
  switchToKyrgyz: () => {},
  switchToTajik: () => {},
})

const IntlProviderWrapper = observer(({ children }) => {
  const appStore = useStore('appStore')

  useEffect(() => {
    setDefaultLocale(appStore.currentLanguage)
  }, [appStore.currentLanguage])

  const switchToEnglish = () => {
    appStore.setLanguage('en')
  }

  const switchToRussian = () => {
    appStore.setLanguage('ru')
  }

  const switchToKyrgyz = () => {
    appStore.setLanguage('kg')
  }

  const switchToTajik = () => {
    appStore.setLanguage('tj')
  }

  const lang = appStore.currentLanguage || 'ru'

  return (
    <IntlContext.Provider value={{ switchToEnglish, switchToRussian, switchToKyrgyz, switchToTajik }}>
      <IntlProvider
        locale={lang}
        messages={messages[lang]}
        defaultLocale={lang}
        onError={err => {
          // lang === 'kg' ? null : console.error(err)
          // lang === 'tj' ? null : console.error(err)

          if (err.code === ReactIntlErrorCode.MISSING_DATA) {
            return
          }
          console.error(err)
        }}
        key={lang}
      >
        {children}
      </IntlProvider>
    </IntlContext.Provider>
  )
})

const useIntlContext = () => useContext(IntlContext)

export { IntlContext, useIntlContext }
export default IntlProviderWrapper
